import { TableLoss } from './TableLoss'

export default TableLoss
